<div (click)="clientSideRotate()">
    <span class="hd-icon hd-icon-rotate-device-right icon-lg client-side-rotation-icon"></span>
</div>

